var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1489 38.3901C65.0611 38.3901 67.4219 36.0294 67.4219 33.1172C67.4219 30.205 65.0609 27.8442 62.1487 27.8442C59.2362 27.8442 56.875 30.2052 56.875 33.1176V38.3901H62.1489ZM47.3828 38.3901C50.2953 38.3901 52.6563 36.0291 52.6563 33.1167V18.352C52.6563 15.4396 50.2953 13.0786 47.3828 13.0786C44.4704 13.0786 42.1094 15.4396 42.1094 18.352V33.1167C42.1094 36.0291 44.4704 38.3901 47.3828 38.3901Z",
    fill: "#2EB67D",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8511 42.6099C14.9389 42.6099 12.5781 44.9707 12.5781 47.8828C12.5781 50.795 14.9391 53.1558 17.8513 53.1558C20.7638 53.1558 23.125 50.7948 23.125 47.8824V42.6099H17.8511ZM32.6172 42.6099C29.7047 42.6099 27.3438 44.9709 27.3438 47.8833V62.648C27.3438 65.5604 29.7047 67.9214 32.6172 67.9214C35.5296 67.9214 37.8906 65.5604 37.8906 62.648V47.8833C37.8906 44.9709 35.5296 42.6099 32.6172 42.6099Z",
    fill: "#E01E5A",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1098 62.6489C42.1098 65.5611 44.4706 67.9219 47.3828 67.9219C50.295 67.9219 52.6558 65.5608 52.6558 62.6487C52.6558 59.7362 50.2948 57.375 47.3823 57.375L42.1098 57.375L42.1098 62.6489ZM42.1098 47.8828C42.1098 50.7952 44.4708 53.1562 47.3832 53.1562L62.1479 53.1562C65.0604 53.1562 67.4214 50.7953 67.4214 47.8828C67.4214 44.9704 65.0604 42.6094 62.1479 42.6094L47.3832 42.6094C44.4708 42.6094 42.1098 44.9704 42.1098 47.8828Z",
    fill: "#ECB22E",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8901 18.3511C37.8901 15.4389 35.5293 13.0781 32.6171 13.0781C29.7049 13.0781 27.3441 15.4391 27.3441 18.3513C27.3441 21.2638 29.7051 23.625 32.6176 23.625L37.8901 23.625L37.8901 18.3511ZM37.8901 33.1172C37.8901 30.2047 35.5291 27.8438 32.6166 27.8438L17.8519 27.8438C14.9395 27.8438 12.5785 30.2047 12.5785 33.1172C12.5785 36.0296 14.9395 38.3906 17.8519 38.3906L32.6166 38.3906C35.5291 38.3906 37.8901 36.0296 37.8901 33.1172Z",
    fill: "#36C5F0",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLight);
export default __webpack_public_path__ + "static/media/slack-light.9114fe6e9bb9b38ffe6a066c163f5a98.svg";
export { ForwardRef as ReactComponent };